export function isEoaWallet () {
  return ['metamask', 'walletconnect_v2'].indexOf(localStorage.getItem('particle_connect_cached_provider')) !== -1
}
